import axios from 'axios';
import { appConfig } from 'app/config/appConfig';

export const getTokenFromRefreshToken = async (refreshToken: string) => {
  try {
    const response = await axios.post(`${appConfig.apiBaseUrl}/v1/auth/refresh`, null, {
      headers: {
        Authorization: `Bearer ${refreshToken}`,
      },
    });

    return response;
  } catch (error) {
    console.log({ error });
  }
};
